import type { JSX } from 'react';
import CourseDetails from '../components/CourseDetails';

const COURSES = [
  {
    title: 'Basic course',
    eligibility: 'Children from the age group of 8-16 years and Adults',
    duration: '30 classes in 3 months',
    syllabus: [
      'Basic concepts of colours and shapes',
      'Use of different mediums: pencil shading, oil pastels, water and poster colours',
      'Nature drawing, object drawing, perspective, memory drawing',
      'Still life, printmaking, creative design',
    ],
  },
  {
    title: 'Advanced course',
    eligibility: 'Students who have a basic knowledge in drawing and painting',
    duration: '6 months/1 year',
    syllabus: [
      'Nature study and object drawing using different mediums',
      'viz pencil shading, oil pastels, water and poster colours',
      'Still life, drawing and rendering in different mediums',
      'Drawing landscapes and figurative drawing',
      'Anatomy and portraits',
    ],
  },
  {
    title: 'Oil painting course',
    eligibility: 'Students who have a basic knowledge in drawing and painting',
    duration: '1 year',
    syllabus: [
      'Introduction to oil colours',
      'Drawing objects and painting on canvas board',
      'Painting landscapes and floral designs on canvas board',
      'Painting animals, birds, human figures and portraits on canvas board',
    ],
  },
] as const;

export default function Courses(): JSX.Element {
  return (
    <main className="mx-auto max-w-3xl px-4 py-12">
      <div className="flex flex-col gap-4">
        {COURSES.map((course) => (
          <CourseDetails
            key={course.title}
            title={course.title}
            eligibility={course.eligibility}
            duration={course.duration}
            syllabus={[...course.syllabus]}
          />
        ))}
      </div>
    </main>
  );
}
